import * as THREE from 'three';
// import matcapTextureUrl from '../assets/matcap-porcelain-white.jpg';
import matcapTextureBrown from '../assets/D4855F_92512D_AE6742_A75C2C-512px.png';
import matcapTextureWhite from '../assets/matcap-porcelain-white.jpg';

export function CreateRectificationPreviewMaterial(opacity = 0.5)
{
    // const mat = originalMaterial.clone();
    // mat.wireframe = false;
    // mat.transparent = true;
    // mat.depthTest = false;
    // mat.depthWrite = false;
    // mat.vertexColors = false;
    // mat.opacity = opacity;
    // mat.color.set(0x008eff);

    const m = new THREE.MeshMatcapMaterial({
        color: 0x008eff,
        transparent: true,
        opacity: opacity,
        side: THREE.DoubleSide,
    });
    return m;
}

export function CreateCarveReliefPreviewMaterial(opacity = 0.5)
{
    const m = new THREE.MeshStandardMaterial({
        color: 0x008eff,
        transparent: true,
        opacity: opacity,
        side: THREE.DoubleSide,
        depthTest: true,
        depthWrite: true,
        // polygonOffset: true,
        // polygonOffsetFactor: 0.1,
        // polygonOffsetUnits: 1.0,
    });
    return m;
}

export function CreateRectificationZonePreviewMaterial(originalMaterial)
{
    // const mat = originalMaterial.clone();
    // mat.transparent = true;
    // mat.depthTest = false;
    // mat.vertexColors = true;
    // mat.opacity = 0.8;
    // mat.color.set(0x008eff);
    // const mat = new THREE.MeshNormalMaterial({
    //     transparent: true,
    //     opacity: 0.8,
    //     depthTest: true,
    //     vertexColors: true,
    //     side: THREE.FrontSide,
    // });
    const matcapTextureLoader = new THREE.TextureLoader();
    const matcapTexture = matcapTextureLoader.load(matcapTextureBrown);
    const mat = new THREE.MeshMatcapMaterial({
        matcap: matcapTexture,
        side: THREE.DoubleSide,
    });
    return mat;
}

export function CreateSmoothingPreviewMaterial(){
    const matcapTextureLoader = new THREE.TextureLoader();
    const matcapTexture = matcapTextureLoader.load(matcapTextureWhite);
    const mat = new THREE.MeshMatcapMaterial({
        matcap: matcapTexture,
        side: THREE.DoubleSide,
    });
    return mat;
}

export function CreateElongationPreviewMaterial(opacity = 0.5)
{
    const m = new THREE.MeshMatcapMaterial({
        color: 0x008eff,
        transparent: true,
        opacity: opacity,
        side: THREE.DoubleSide,
    });
    return m;
}

export function CreateThicknessPreviewMaterial(opacity = 0.4)
{
    const m = new THREE.MeshMatcapMaterial({
        color: 0xff6b35, // Orange color to distinguish from elongation
        transparent: true,
        opacity: opacity,
        side: THREE.DoubleSide,
        depthTest: true,
        depthWrite: true, // Enable depth write for solid shell visualization
        polygonOffset: true,
        polygonOffsetFactor: 0.5,
        polygonOffsetUnits: 1.0,
    });
    return m;
}

export function CreateTopMeshPreviewMaterial(opacity = 0.3)
{
    const m = new THREE.MeshMatcapMaterial({
        color: 0x35a8ff, // Light blue color to distinguish from bottom thickness
        transparent: true,
        opacity: opacity,
        side: THREE.DoubleSide,
        depthTest: true,
        depthWrite: true,
        polygonOffset: true,
        polygonOffsetFactor: 0.3,
        polygonOffsetUnits: 0.5,
    });
    return m;
}

export function CreateFlarePreviewMaterial(opacity = 0.5)
{
    // Base preview should not be visible; overlays provide the visual.
    // Make the base fully transparent and avoid writing to the depth/color buffers
    // so the original shaded mesh remains visible wherever there is no overlay.
    const m = new THREE.MeshMatcapMaterial({
        color: 0xffffff,
        transparent: true,
        opacity: opacity,
        side: THREE.DoubleSide,
        depthTest: false,
        depthWrite: false,
        colorWrite: false,
        polygonOffset: true,
        polygonOffsetFactor: 0.4,
        polygonOffsetUnits: 0.8,
        vertexColors: true,
    });
    return m;
}